import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APIClient } from "src/app/core/api-client/contracts/api-client.service";
import { ICreateDevice, IDevice } from "src/app/shared/models/IDevice";
import { IDeviceType } from "src/app/shared/models/IDevice-type";

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  resource = 'devices';
  constructor(private client: APIClient) { }
  getAllDevices(facilityId: number): Observable<IDevice[]> {
    return this.client.get<IDevice[]>(`${this.resource}/${facilityId}`)
  }
  GetAllDeviceTypes(): Observable<IDeviceType[]> {
    return this.client.get<IDeviceType[]>(`${this.resource}/getalldevicetypes`);
  }
  getActiveDevicesCountByDeviceIdentifier(deviceIdentifier: string, deviceTypeId: number): Observable<number> {
    return this.client.get<number>(`${this.resource}/activeDevicesCount/${deviceIdentifier}/${deviceTypeId}`)
  }
  createAdminDevice(device: ICreateDevice): Observable<ICreateDevice> {
    return this.client.post<ICreateDevice>(`${this.resource}/createAdminDevice`, device);
  }
}